module.exports = __webpack_public_path__ + "img/headbg1.aec586d3.png";